module.exports = __webpack_public_path__ + "Participant HSA Notice 07_31_2024.pdf";